import "./Lable.css"


const Lable = ({lable}) => {
    return(
    <p className="Lable">{lable}</p>
    );
}

export default Lable;